import { z } from "zod";

export const initialValues=(selectedCountry)=>{
    return {
        designation: "",
        email: "",
        firstName: "",
        lastName: "",
        employeeCode: "",
        avatar: "",
        location: "",
        country: selectedCountry ? selectedCountry.value : "",
        driverDetails: {
          driverId: "",
          dollasId: "",
          mobileNumber: "",
          dateOfBirth: "",
          dateOfJoin: "",
          nationality: "",
          region: "",
          driverType: "",
          licenseNumber: "",
          licenseCity: "",
          licenseIssuedDate: "",
          licenseExpiredDate: "",
          drivingLicenseType: "",
          passportNumber: "",
          passportIssueDate: "",
          passportExpireDate: "",
          visaNumber: "",
          visaCity: "",
          visaIssueDate: "",
          visaExpiredDate: "",
        },
      }
}

export const schema =(selecteduserType,userId)=> z.object({
    designation: z.string().min(1, "Please type designation"),
    avatar: z.string().optional(),
    country: z.string().min(1, "Please select a country"),
    location: z.string().optional(),
    vehicleId: z.string().optional(),
    tagId: z.string().optional(),
    firstName: z.string().nullish(),
    lastName: z.string().min(1, "Field is required"),
    employeeCode: z.string().min(1, "Please type employee code"),
    email: z
      .string()
      .min(1, "Please type email")
      .email("This is not a valid email."),
    password: z.string().superRefine((value, ctx) => {
      // const { userType } = ctx.form.$data;
      if (selecteduserType === "driver" && !userId && value.length <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Password is required",
          path: ["password"],
          fatal: true,
        });
      }
    }),
  });